import { render, staticRenderFns } from "./ReceiptsHeader.vue?vue&type=template&id=5d6464ab&"
import script from "./ReceiptsHeader.vue?vue&type=script&lang=js&"
export * from "./ReceiptsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d6464ab')) {
      api.createRecord('5d6464ab', component.options)
    } else {
      api.reload('5d6464ab', component.options)
    }
    module.hot.accept("./ReceiptsHeader.vue?vue&type=template&id=5d6464ab&", function () {
      api.rerender('5d6464ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/receipts/views/components/ReceiptsHeader.vue"
export default component.exports